import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  createItinerariesApi,
  editItinerariesApi,
  getItinerariesApi,
  deleteItineraryDaysDataApi,
  deleteDestinationCityApi,
  deleteDestinationCityDaysApi,
} from "../../../services/AdminService";
import { googleApiKey } from "../../../services/CommonUrl";
// import NumericInput from 'react-numeric-input';
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Spinner from "react-bootstrap/Spinner";
import Form from "react-bootstrap/Form";
import DatePicker from "react-datepicker";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";

import soloIcon from "../../../assets/images/solo-icon.png";
import coupleIcon from "../../../assets/images/couple-icon.png";
import familyIcon from "../../../assets/images/family-icon.png";
import groupIcon from "../../../assets/images/group-icon.png";

import Autocomplete from "react-google-autocomplete";
import moment from "moment";
import Swal from "sweetalert2";
import { toast, Slide } from "react-toastify";
import { useAuth } from "../../../contexts/AuthProvider";
import OthersModal from "./options/OthersModal";
import ToursModal from "./options/ToursModal";
import StaysModal from "./options/StaysModal";
import TransportModal from "./options/TransportModal";
import FoodModal from "./options/FoodModal";
import ActivitiesModal from "./options/ActivitiesModal";
import DayItem from "./components/DayItem";
import { dayNumber, extractLocationData, timeFunc } from "../../../helpers";
import { CreateItineraryPlaceholder } from "../../../components/skeleton-placeholder";
const options = {
  position: "top-center",
  hideProgressBar: true,
  transition: Slide,
  theme: "colored",
  closeButton: false,
  autoClose: 2000,
  showDuration: 300,
  hideDuration: 1000,
};
const CreateItinerary = () => {
  const formRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const searchPrams = new URLSearchParams(location.search);
  const itineraryId = searchPrams.get("itineraryId") || null;
  const [isLoading, setIsLoading] = useState(false);
  const [showFoodModal, setShowFoodModal] = useState(false);
  const [showActivityModal, setShowActivityModal] = useState(false);
  const { authed, currencyData } = useAuth();
  const [validated, setValidated] = useState(false);
  const [checkDate, setcheckDate] = useState(null);

  const [isDataLoading, setIsDataLoading] = useState(false);
  const [color, setColor] = useState("");

  const [showTransportModal, setShowTransportModal] = useState(false);
  const [showOtherModal, setShowOtherModal] = useState(false);
  const [dayData, setDayData] = useState(null);
  const [destinationData, setDestinationData] = useState(null);
  const [showToursModal, setShowToursModal] = useState(false);
  const [showStaysModal, setShowStaysModal] = useState(false);
  const [editable, setEditable] = useState(false);
  const [itemData, setItemData] = useState(null);

  const [removeDays, setRemoveDays] = useState([]);
  const [checkDateBlank, setCheckDateBlank] = useState(false);
  const [activeDayKey, setActiveDayKey] = useState('days1');
  const [activeDestinationKey, setActiveDestinationKey] = useState('desItem0');

  const numArray = [
    {
      day: 1,
      date: checkDate ? moment(checkDate).format("DD MMMM yyyy") : null,
    },
  ];
  const multiDesArr = [
    {
      itineraryDatys: numArray,
      tour_start_date: "",
      tour_no_of_days: 1,
      destination_city: {
        iso_code: "",
        country: "",
        city: "",
        destination_address: "",
        lat: "",
        lng: ""
      },
      from_city: {
        iso_code: "",
        country: "",
        city: "",
        from_address: "",
        lat: "",
        lng: ""
      },
    },
  ];
  const initialGetItData = {
    type_of_itinerary: "",
    tour_name: "",
    type_of_tour: "",
    destinationCityDetails: multiDesArr,
    travellers_type: "",
    no_adult_travellers: 1,
    no_infant_travellers: 0,
    no_children_travellers: {
      no_children: 0,
      children_age: [],
    },
  };
  const [itinariesDataGet, setItinariesDataGet] = useState(initialGetItData);

  const handleChange = (e) => {
    setItinariesDataGet({
      ...itinariesDataGet,
      [e.target.name]: e.target.value,
    });
    setColor(true);
  };

  const handleSelectLocation = (place, index, type) => {
    setColor(true);
    const { city, country, iso_code, lat, lng, address } = extractLocationData(place);
    if (!city || !country) return;

    setItinariesDataGet((prevState) => {
      return {
        ...prevState,
        destinationCityDetails: prevState.destinationCityDetails.map((detail, i) => {
          if (i === index) {
            if (type === "destination_city" && detail.from_city.from_address === address) {
              toast.warning("Can't select the same city", options);
              return { ...detail, destination_city: { country: "", city: "", iso_code: "", lat: "", lng: "", destination_address: "" } };
            }

            return {
              ...detail,
              [type]: {
                country,
                city,
                iso_code,
                lat,
                lng,
                [type === "from_city" ? "from_address" : "destination_address"]: address,
              },
            };
          }

          if (type === "destination_city" && i === index + 1) {
            return {
              ...detail,
              from_city: { country, city, iso_code, lat, lng, from_address: address },
            };
          }

          return detail;
        }),
      };
    });
  };

  const handleChangeFromToAddress = (e, index, type) => {

    const CityData = itinariesDataGet.destinationCityDetails[index][type];
    if (!CityData.city && !CityData.country) {
      setColor(true);
    }

    setItinariesDataGet((prevState) => ({
      ...prevState,
      destinationCityDetails: prevState.destinationCityDetails.map((d, i) =>
        i === index
          ? {
            ...d,
            [type]: {
              ...d[type],
              [type === "from_city" ? "from_address" : "destination_address"]: e.target.value,
              iso_code: "",
              city: "",
              country: "",
              lat: "",
              lng: ""
            },
          }
          : d
      ),
    }));
  };

  const handleBlurFromToAddress = (e, index, type, fieldKey) => {
    const CityData = itinariesDataGet.destinationCityDetails[index][type];
    if (!CityData.city && !CityData.country) {
      setColor(true);
    }
    if (!CityData.city && !CityData.country) {
      setItinariesDataGet((prevData) => {
        const updatedData = { ...prevData };
        updatedData.destinationCityDetails[index][type][fieldKey] = "";
        return updatedData;
      });
    }
  };

  const onValueChange = (event) => {
    const updatedItinerary = {
      ...itinariesDataGet,
      destinationCityDetails: multiDesArr,
      type_of_tour: event.target.value,
    };
    setItinariesDataGet(updatedItinerary);
    setColor(true);
  };

  const totalTraveller = Number(
    itinariesDataGet.no_adult_travellers +
    itinariesDataGet.no_children_travellers.no_children +
    itinariesDataGet.no_infant_travellers
  );

  const adultsdecrementCount = () => {
    if (itinariesDataGet.no_adult_travellers > 1) {
      itinariesDataGet.no_adult_travellers =
        itinariesDataGet.no_adult_travellers - 1;
      travellersTypeCount();
    }
    setColor(true);
  };
  const adultsincrementCount = () => {
    if (totalTraveller < 9) {
      itinariesDataGet.no_adult_travellers =
        itinariesDataGet.no_adult_travellers + 1;
      travellersTypeCount();
    }
    setColor(true);
  };

  const childdecrementCount = () => {
    if (itinariesDataGet.no_children_travellers.no_children > 0) {
      itinariesDataGet.no_children_travellers.no_children =
        itinariesDataGet.no_children_travellers.no_children - 1;
      itinariesDataGet.no_children_travellers.children_age.pop("");
      travellersTypeCount();
    }
    setColor(true);
  };
  const childincrementCount = () => {
    if (totalTraveller < 9) {
      itinariesDataGet.no_children_travellers.no_children =
        itinariesDataGet.no_children_travellers.no_children + 1;
      itinariesDataGet.no_children_travellers.children_age.push("");
      travellersTypeCount();
    }
    setColor(true);
  };

  const infantsdecrementCount = () => {
    if (itinariesDataGet.no_infant_travellers > 0) {
      itinariesDataGet.no_infant_travellers =
        itinariesDataGet.no_infant_travellers - 1;
      travellersTypeCount();
    }
    setColor(true);
  };
  const infantsincrementCount = () => {
    if (totalTraveller < 9) {
      itinariesDataGet.no_infant_travellers =
        itinariesDataGet.no_infant_travellers + 1;
      travellersTypeCount();
    }
    setColor(true);
  };

  const onChangeChildAge = (e, i) => {
    setColor(true);
    itinariesDataGet.no_children_travellers.children_age[i] = e.target.value;
    setItinariesDataGet({ ...itinariesDataGet });
  };

  const travellersTypeCount = () => {
    const totalTravellerCnt =
      Number(itinariesDataGet.no_adult_travellers || 0) +
      Number(itinariesDataGet.no_children_travellers?.no_children || 0) +
      Number(itinariesDataGet.no_infant_travellers || 0);

    let travellersType = "Solo";

    if (totalTravellerCnt === 2) {
      travellersType = "Couple";
    } else if (totalTravellerCnt > 2 && totalTravellerCnt <= 4) {
      travellersType = "Family";
    } else if (totalTravellerCnt > 4) {
      travellersType = "Group";
    }
    setItinariesDataGet((prev) => ({ ...prev, travellers_type: travellersType }));
  };

  const handleDateChange = (date, d) => {
    setColor(true);
    setcheckDate(date);
    itinariesDataGet.destinationCityDetails[d].tour_start_date =
      moment(date).format("DD MMMM yyyy");
    itinariesDataGet.destinationCityDetails[d].itineraryDatys[0].date =
      moment(date).format("DD MMMM yyyy");
    for (
      let l = 0;
      l < itinariesDataGet.destinationCityDetails[d].itineraryDatys.length;
      l++
    ) {
      itinariesDataGet.destinationCityDetails[d].itineraryDatys[l].date =
        moment(itinariesDataGet.destinationCityDetails[d].tour_start_date).add(
          l,
          "days"
        );
    }

    setItinariesDataGet({ ...itinariesDataGet });
    // console.log("inside", itinariesDataGet.destinationCityDetails)
  };

  const handleRemove = (e, daysitem, destinationitem, i, idx) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      text: "This day will be deleted permanently",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (itinariesDataGet.destinationCityDetails[i].tour_no_of_days > 0) {
          setColor(true);
          let removeObj =
            destinationitem?.itineraryDatys[
            destinationitem?.itineraryDatys.length - 1
            ];
          let itiArrRmv =
            itinariesDataGet.destinationCityDetails[i].itineraryDatys;
          let index = itiArrRmv.indexOf(idx);
          itiArrRmv.splice(index, 1);
          itinariesDataGet.destinationCityDetails[i].tour_no_of_days = Number(
            itinariesDataGet.destinationCityDetails[i].itineraryDatys.length
          );
          setItinariesDataGet({ ...itinariesDataGet });
          if (removeObj._id) {
            // console.log("=====removeObj=======>", removeObj);
            let temp = {
              destinationCityId: removeObj.destinationCityId,
              itineraryId: removeObj.itineraryId,
              daysId: removeObj._id,
            };
            setRemoveDays((state) => [...state, temp]);
          }
          if (daysitem._id) {
            // let obj = {
            //   destinationCityId: daysitem.destinationCityId,
            //   itineraryId: daysitem.itineraryId,
            //   daysId: daysitem._id,
            // };

            // await deleteDestinationCityDaysApi(obj, async (res) => {
            //   console.log("res deleteDestinationCityDaysApi", res);
            //   if (res.status === 200) {
            //     // console.log("Day item Deleted successfully.");
            //     //getDraftData(itineraryId);
            //     handleCreateItinaries();
            //   } else {
            //     console.log(
            //       `Error: ${
            //         res.data?.message || "An unexpected error occurred."
            //       }`
            //     );
            //   }
            // });
          }
        }
      }
    });
  };

  const validTimeFormat = (date) => {
    const format = "DD MMMM YYYY";
    const dateConvert = moment(date, format, true).isValid()
      ? moment(date, "DD MMMM YYYY").utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
      : date;

    return dateConvert;
  };

  const compareTime = (d1, d2) => {
    const date1 = moment(validTimeFormat(d1), "YYYY-MM-DD").add(1, "days");
    const date2 = moment(validTimeFormat(d2), "YYYY-MM-DD");
    // Compare the dates
    if (date1.isBefore(date2)) {
      return true;
    } else {
      return false;
    }
  };

  const handleAddItem = async (e, destinationitem, i) => {
    e.preventDefault();
    if (
      itinariesDataGet.type_of_tour == "Multi City" &&
      itinariesDataGet.destinationCityDetails[i + 1]
    ) {
      let beforeTime = compareTime(
        itinariesDataGet.destinationCityDetails[i].itineraryDatys[
          itinariesDataGet.destinationCityDetails[i].itineraryDatys.length - 1
        ].date,
        itinariesDataGet.destinationCityDetails[i + 1].tour_start_date
      );
      // console.log("====beforeTime======>", beforeTime);
      if (!beforeTime) {
        Swal.fire({
          title: "The selected date is outside the allowed range",
          text: "Please choose a date within the specified range.",
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok",
        });
        return;
      }
    }
    itinariesDataGet.destinationCityDetails[i].itineraryDatys.push({
      day:
        Number(
          itinariesDataGet.destinationCityDetails[i].itineraryDatys[
            itinariesDataGet.destinationCityDetails[i].itineraryDatys.length - 1
          ].day
        ) + 1,

      date: moment(
        itinariesDataGet.destinationCityDetails[i].itineraryDatys[
          itinariesDataGet.destinationCityDetails[i].itineraryDatys.length - 1
        ].date
      )
        .add(1, "days")
        .format("DD MMMM YYYY"),
    });
    itinariesDataGet.destinationCityDetails[i].tour_no_of_days = Number(
      itinariesDataGet.destinationCityDetails[i].itineraryDatys.length
    );
    setItinariesDataGet({ ...itinariesDataGet });
    setColor(true);
  };
  // Submit Form for create and edit
  const state = { button: 1 };
  const handleCreateItinaries = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (state.button === 1) {
      // console.log(form)
      if (form.checkValidity() === false) {
        e.stopPropagation();
      }
      setValidated(true);
      if (form.checkValidity() === true) {
        setIsDataLoading(true);
        const Obj = {
          userId: authed?.user?._id,
          travellers_type: itinariesDataGet.travellers_type,
          tour_name: itinariesDataGet.tour_name,
          type_of_tour: itinariesDataGet.type_of_tour,
          currency: currencyData?.currency,
          destinationCityDetails: itinariesDataGet.destinationCityDetails,
          no_adult_travellers: itinariesDataGet.no_adult_travellers,
          no_infant_travellers: itinariesDataGet.no_infant_travellers,
          no_children_travellers: {
            no_children: itinariesDataGet.no_children_travellers.no_children,
            children_age: itinariesDataGet.no_children_travellers.children_age,
          },
        };
        await createItinerariesApi(Obj, async (res) => {
          setIsDataLoading(false);
          if (res.status === 200) {
            // console.log("res Itineraries one way Api ====", res.data.data._id);
            if (res?.data?.success) {
              history.push({
                pathname: "/admin/create-itinerary/",
                search: `itineraryId=${res.data.data._id}`,
                state: {
                  userId: res.data.data.userId,
                  itineraryId: res.data.data._id,
                },
              });
              getDraftData(res.data.data._id);
            }
          } else if (res.status === 422) {
            console.error("Validation Error:", res.data);
          } else {
            console.error(`Error: ${res.data?.message || "An unexpected error occurred."}`);
          }
        });
        setColor(false);
      }
    }
    if (state.button === 2) {
      if (form.checkValidity() === false) {
        e.stopPropagation();
      }
      setValidated(true);
      if (form.checkValidity() === true) {
        // console.log("Button 2 clicked! valid");
        setIsDataLoading(true);
        const Obj = {
          userId: authed.user._id,
          itineraryId: itineraryId,
          travellers_type: itinariesDataGet.travellers_type,
          tour_name: itinariesDataGet.tour_name,
          type_of_tour: itinariesDataGet.type_of_tour,
          currency: currencyData?.currency,
          destinationCityDetails: itinariesDataGet.destinationCityDetails,
          no_adult_travellers: itinariesDataGet.no_adult_travellers,
          no_infant_travellers: itinariesDataGet.no_infant_travellers,
          no_children_travellers: {
            no_children: itinariesDataGet.no_children_travellers.no_children,
            children_age: itinariesDataGet.no_children_travellers.children_age,
          },
          removeDays: removeDays,
        };
        await editItinerariesApi(Obj, async (res) => {
          // console.log("res saveItinerariesApi ====", res);
          setIsDataLoading(false);
          if (res.status === 200) {
            setRemoveDays([]);
            getDraftData(itineraryId);
          } else {
            console.log(
              `Error: ${res.data?.message || "An unexpected error occurred."}`
            );
          }
        });
        setColor(false);
      }
    }
  };
  const getDraftData = async (itineraryId) => {
    setIsLoading(true);
    const Obj = {
      userId: authed.user._id,
      itineraryId: itineraryId,
    };
    await getItinerariesApi(Obj, async (res) => {
      // console.log("res getItinerariesApi ====", res.data);
      setIsLoading(false);
      if (res.status === 200) {
        const { data } = res.data;
        setItinariesDataGet(data);
        CheckDateBlankFnc(data.destinationCityDetails);
        if (data.tour_name === "") {
          setColor(true);
        }
      } else {
        console.log(
          `Error: ${res.data?.message || "An unexpected error occurred."}`
        );
      }
    });
  };
  const handleItineraryDaysDataDelete = async (data) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This activity will be deleted permanently",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let obj = {
          _id: data._id,
          days_type: data.days_type,
        };

        await deleteItineraryDaysDataApi(obj, async (res) => {
          // console.log("res deleteItineraryDaysDataApi ====", res);
          if (res.status === 200) {
            getDraftData(itineraryId);
          } else {
            console.log(
              `Error: ${res.data?.message || "An unexpected error occurred."}`
            );
          }
        });
      }
    });
  };
  // Start Stays Functions

  const addMultiDesFields = (e, data, index) => {
    // console.log("addMultiDesFields===>", data, index)
    setColor(true);
    e.preventDefault();
    const form = formRef.current;
    if (!form.checkValidity()) {
      setValidated(true);
      return;
    }
    setValidated(false);
    const daysLastDate = data.itineraryDatys[data.itineraryDatys.length - 1].date;
    itinariesDataGet.destinationCityDetails.push({
      itineraryDatys: [
        {
          day: 1,
          date:
            data.tour_start_date === null
              ? null
              : moment(daysLastDate).add(1, "days"),
        },
      ],
      tour_start_date:
        data.tour_start_date === null
          ? null
          : moment(daysLastDate).add(1, "days"),
      tour_no_of_days: 1,
      destination_city: {
        iso_code: "",
        country: "",
        city: "",
        destination_address: "",
        lat: "",
        lng: ""
      },
      from_city: {
        iso_code: data.destination_city.iso_code,
        country: data.destination_city.country,
        city: data.destination_city.city,
        from_address:
          data.destination_city.destination_address === ""
            ? ""
            : `${data.destination_city.city +
            ", " +
            data.destination_city.country
            }`,
      },
      lat: data.destination_city.lat,
      lng: data.destination_city.lng
    });
    setItinariesDataGet({ ...itinariesDataGet });
  };

  const removeMultiDesFields = (i, data) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This destination will be deleted permanently",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setColor(true);
        itinariesDataGet.destinationCityDetails.splice(i, 1);
        setItinariesDataGet({ ...itinariesDataGet });
        if (data._id) {
          let obj = {
            destinationCityId: data._id,
            itineraryId: data.itineraryId,
          };
          await deleteDestinationCityApi(obj, async (res) => {
            if (res.status === 200) {
              // console.log("Data Delete successfully.");
              getDraftData(itineraryId);
            } else {
              console.log(
                `Error: ${res.data?.message || "An unexpected error occurred."}`
              );
            }
          });
        }
      }
    });
  };

  const dayCount = (i) => {
    let s = 0;
    for (let j = 0; j <= i; j++) {
      s += Number(itinariesDataGet?.destinationCityDetails[j]?.tour_no_of_days);
    }
    return s;
  };

  const checkNullItinerary = itinariesDataGet.destinationCityDetails.some(
    (element) => {
      return element.tour_start_date === null;
    }
  );

  useEffect(() => {
    if (itineraryId) {
      getDraftData(itineraryId);
    } else {
      setItinariesDataGet(initialGetItData);
    }
    travellersTypeCount();
  }, [itineraryId]);

  const editItineraryFunc = (item) => {
    setEditable(true);
    setItemData(item);
    // console.log("====edit Itinerary====>", item.days_type);
    if (item.days_type == "Transports") setShowTransportModal(true);
    if (item.days_type == "Stays") setShowStaysModal(true);
    if (item.days_type == "Activity") setShowActivityModal(true);
    if (item.days_type == "Tours") setShowToursModal(true);
    if (item.days_type == "Food") setShowFoodModal(true);
    if (item.days_type == "Others") setShowOtherModal(true);
  };

  const CheckDateBlankFnc = (data) => {
    if (!Array.isArray(data) || data.length === 0) return true;
    const hasAnyBlankDate = data.some((item) =>
      item.tour_start_date === null ||
      item.tour_start_date === undefined ||
      item.tour_start_date === ""
    );
    setCheckDateBlank(hasAnyBlankDate);
    return hasAnyBlankDate;
  };

  // console.log("======itineraryId========>", itineraryId);
  // console.log("======itinariesDataGet========>", itinariesDataGet);



  return (
    <>
      <div className="content-body create-itinarary-wrap">
        <h1 className="d-col-title mb-3">Create Itinerary</h1>

        <Form noValidate validated={validated} onSubmit={handleCreateItinaries} ref={formRef}>
          {isLoading ? (
            <CreateItineraryPlaceholder />
          ) : (
            <>
              <div className="d-span-row">
                <div className="d-col-8">
                  <div className="d-col-input-field">
                    <Form.Group controlId="TourName">
                      <Form.Control
                        onChange={handleChange}
                        name="tour_name"
                        value={itinariesDataGet.tour_name}
                        placeholder="Tour Name"
                        required
                      />
                    </Form.Group>
                  </div>
                  <div className="mt-3 d-col-radio-field">
                    {itineraryId ? (
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          checked={true}
                          type="radio"
                        />
                        <label className="form-check-label">
                          {itinariesDataGet.type_of_tour}
                        </label>
                      </div>
                    ) : (
                      <>
                        <Form.Group
                          className="d-col-radio-field"
                          controlId="typeOfTourControl"
                        >
                          <Form.Check
                            type="radio"
                            label="One Way"
                            onChange={onValueChange}
                            name="type_of_tour"
                            checked={
                              itinariesDataGet.type_of_tour === "One Way"
                            }
                            value="One Way"
                            id="OneWay"
                            required
                          />
                          <Form.Check
                            type="radio"
                            label="Round Trip"
                            onChange={onValueChange}
                            name="type_of_tour"
                            checked={
                              itinariesDataGet.type_of_tour === "Round Trip"
                            }
                            value="Round Trip"
                            id="RoundTrip"
                            required
                          />
                          <Form.Check
                            type="radio"
                            label="Multi City"
                            onChange={onValueChange}
                            name="type_of_tour"
                            checked={
                              itinariesDataGet.type_of_tour === "Multi City"
                            }
                            value="Multi City"
                            id="MultiCity"
                            required
                          />
                        </Form.Group>
                      </>
                    )}
                  </div>
                  <div className="row">
                    {itinariesDataGet.type_of_tour === "One Way" ||
                      itinariesDataGet.type_of_tour === "Round Trip" ? (
                      <>
                        <div className="col-md-12 mt-3">
                          <div className="multi-city-row">
                            <div className="multi-city-item position-relative">
                              <div className="d-col-input-field">
                                <label className="form-label">Going From</label>
                                <Form.Group controlId="validationGoingFrom">
                                  <Autocomplete
                                    apiKey={`${googleApiKey}`}
                                    options={{ types: ["(cities)"] }}
                                    onPlaceSelected={(place) => handleSelectLocation(place, 0, "from_city")}
                                    value={itinariesDataGet.destinationCityDetails[0].from_city.from_address}
                                    onChange={(e) => handleChangeFromToAddress(e, 0, "from_city")}
                                    onBlur={(e) => handleBlurFromToAddress(e, 0, "from_city", "from_address")}
                                    className="form-control"
                                    placeholder="Enter a Location"
                                    required
                                  />
                                </Form.Group>
                              </div>
                            </div>
                            <div className="multi-city-item">
                              <div className="d-col-input-field">
                                <label className="form-label">Going To</label>
                                <Form.Group controlId="validationGoingTo">
                                  <Autocomplete
                                    apiKey={`${googleApiKey}`}
                                    options={{ types: ["(cities)"] }}
                                    onPlaceSelected={(place) => handleSelectLocation(place, 0, "destination_city")}
                                    value={itinariesDataGet.destinationCityDetails[0].destination_city.destination_address}
                                    onChange={(e) => handleChangeFromToAddress(e, 0, "destination_city")}
                                    onBlur={(e) => handleBlurFromToAddress(e, 0, "destination_city", "destination_address")}
                                    className="form-control"
                                    placeholder="Enter a Location"
                                    required
                                  />
                                </Form.Group>
                              </div>
                            </div>
                            <div className="multi-city-item">
                              <div className="d-col-input-field">
                                <label className="form-label">Depart</label>
                                <Form.Group
                                  controlId="validationStartDate"
                                  className="sd-date-field"
                                >
                                  <label
                                    className="sd-date-icon"
                                    htmlFor="owrt_0"
                                  ></label>
                                  <DatePicker
                                    value={
                                      itinariesDataGet?.destinationCityDetails[0]
                                        ?.tour_start_date
                                        ? moment(
                                          itinariesDataGet
                                            ?.destinationCityDetails[0]
                                            ?.tour_start_date
                                        ).format("DD-MM-YYYY")
                                        : null
                                    }
                                    onChange={(date) => handleDateChange(date, 0)}
                                    name="tour_start_date"
                                    dateFormat="dd MMMM yyyy"
                                    autoComplete="off"
                                    customInput={
                                      <input
                                        className="form-control"
                                        type="text"
                                        readOnly
                                      />
                                    }
                                    placeholderText="Enter Date"
                                    minDate={new Date()}
                                    id="owrt_0"
                                    required
                                  />
                                </Form.Group>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : null}
                    {itinariesDataGet.type_of_tour === "Multi City" ? (
                      <div className="col-md-12 mt-3">
                        {itinariesDataGet.destinationCityDetails.map(
                          (element, i) => {
                            return (
                              <>
                                <div className="multi-city-row rs-multi-city mb-3">
                                  <div className="multi-city-count">{i + 1}</div>
                                  <div className="multi-city-item">
                                    <div className="d-col-input-field">
                                      <label className="form-label">
                                        Going From
                                      </label>
                                      <Form.Group
                                        controlId={`validationGoingFrom${i}`}
                                      >
                                        <Autocomplete
                                          apiKey={`${googleApiKey}`}
                                          options={{ types: ["(cities)"] }}
                                          onPlaceSelected={(place) => handleSelectLocation(place, i, "from_city")}
                                          value={itinariesDataGet.destinationCityDetails[i].from_city.from_address}
                                          onChange={(e) => handleChangeFromToAddress(e, i, "from_city")}
                                          onBlur={(e) => handleBlurFromToAddress(e, i, "from_city", "from_address")}
                                          className="form-control"
                                          placeholder="Enter a Location"
                                          required
                                        />
                                      </Form.Group>
                                    </div>
                                  </div>
                                  <div className="multi-city-item">
                                    <div className="d-col-input-field">
                                      <label className="form-label">Going To</label>
                                      <Form.Group
                                        controlId={`validationGoingTo${i}`}
                                      >
                                        <Autocomplete
                                          apiKey={`${googleApiKey}`}
                                          options={{ types: ["(cities)"] }}
                                          onPlaceSelected={(place) => handleSelectLocation(place, i, "destination_city")}
                                          value={itinariesDataGet.destinationCityDetails[i].destination_city.destination_address}
                                          onChange={(e) => handleChangeFromToAddress(e, i, "destination_city")}
                                          onBlur={(e) => handleBlurFromToAddress(e, i, "destination_city", "destination_address")}
                                          className="form-control"
                                          placeholder="Enter a Location"
                                          required
                                        />
                                      </Form.Group>
                                    </div>
                                  </div>
                                  <div className="multi-city-item">
                                    <div className="d-col-input-field">
                                      <label className="form-label">Depart</label>
                                      <Form.Group
                                        controlId="validationStartDate"
                                        className="sd-date-field"
                                      >
                                        <label
                                          className="sd-date-icon"
                                          htmlFor={`mc_${i + 1}`}
                                        ></label>
                                        <DatePicker
                                          value={
                                            itinariesDataGet.destinationCityDetails[
                                              i
                                            ].tour_start_date
                                              ? moment(
                                                itinariesDataGet
                                                  .destinationCityDetails[i]
                                                  .tour_start_date
                                              ).format("DD-MM-YYYY")
                                              : null
                                          }
                                          onChange={(date) =>
                                            handleDateChange(date, i)
                                          }
                                          name="tour_start_date"
                                          dateFormat="dd MMMM yyyy"
                                          autoComplete="off"
                                          customInput={
                                            <input
                                              className="form-control"
                                              type="text"
                                              readOnly
                                            />
                                          }
                                          placeholderText="Enter Date"
                                          minDate={
                                            i > 0
                                              ? new Date(
                                                itinariesDataGet?.destinationCityDetails[
                                                  i - 1
                                                ]?.tour_start_date
                                              ).setDate(
                                                new Date(
                                                  itinariesDataGet?.destinationCityDetails[
                                                    i - 1
                                                  ]?.tour_start_date
                                                ).getDate() + 1
                                              )
                                              : new Date()
                                          }
                                          required
                                          id={`mc_${i + 1}`}
                                        />
                                      </Form.Group>
                                    </div>
                                  </div>
                                  <div className="multi-city-item-delete">
                                    {i ? (
                                      <button
                                        type="button"
                                        className="btn close-btn btn-secondary-color"
                                        onClick={() =>
                                          removeMultiDesFields(i, element)
                                        }
                                      >
                                        <i className="bi bi-x-circle"></i>
                                      </button>
                                    ) : null}
                                  </div>
                                </div>
                              </>
                            );
                          }
                        )}
                        <div className="d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn btn-primary-color"
                            style={{ fontSize: "14px" }}
                            onClick={(e) =>
                              addMultiDesFields(
                                e,
                                itinariesDataGet.destinationCityDetails[
                                itinariesDataGet.destinationCityDetails.length - 1
                                ],
                                itinariesDataGet.destinationCityDetails.length - 1
                              )
                            }
                          >
                            <i className="bi bi-plus-lg"></i> Add Destination
                          </button>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="d-col-4">
                  <div className="">
                    <div className="d-col-number-group d-flex">
                      <div className="number-form-label">
                        <p>Travellers</p>
                      </div>
                      <div className="d-col-type-bx">
                        {itinariesDataGet.travellers_type === "Solo" && <img src={soloIcon} alt="icon" />}
                        {itinariesDataGet.travellers_type === "Couple" && <img src={coupleIcon} alt="icon" />}
                        {itinariesDataGet.travellers_type === "Family" && <img src={familyIcon} alt="icon" />}
                        {itinariesDataGet.travellers_type === "Group" && <img src={groupIcon} alt="icon" />}
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <div className="d-col-number-group">
                      <div className="number-form-label">
                        <p>
                          Adults <small>14 years & above</small>
                        </p>
                        <p>
                          <small>on the day of travel</small>
                        </p>
                      </div>
                      <div className="d-col-number-field custom-add-rm-btn">
                        <button
                          type="button"
                          disabled={itinariesDataGet.no_adult_travellers < 2}
                          onClick={adultsdecrementCount}
                        >
                          <i className="bi bi-dash"></i>
                        </button>
                        <input
                          type="number"
                          name="adults"
                          value={itinariesDataGet.no_adult_travellers}
                          readOnly
                        />
                        <button type="button" onClick={adultsincrementCount}>
                          <i className="bi bi-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <div className="d-col-number-group">
                      <div className="number-form-label">
                        <p>
                          Children <small>2 to 13 years</small>
                        </p>
                        <p>
                          <small>on the day of travel</small>
                        </p>
                      </div>
                      <div className="d-col-number-field custom-add-rm-btn">
                        <button
                          type="button"
                          disabled={
                            itinariesDataGet.no_children_travellers.no_children < 1
                          }
                          onClick={childdecrementCount}
                        >
                          <i className="bi bi-dash"></i>
                        </button>
                        <input
                          type="number"
                          name="no_children"
                          value={
                            itinariesDataGet.no_children_travellers.no_children
                          }
                          readOnly
                        />
                        <button type="button" onClick={childincrementCount}>
                          <i className="bi bi-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  {[
                    ...Array(
                      Number(itinariesDataGet.no_children_travellers.no_children)
                    ),
                  ].map((childitem, i) => {
                    return (
                      <div key={i} className="mt-3">
                        <div className="d-col-number-group">
                          <div className="number-form-label">
                            <p>
                              Age of child {i + 1} <small> Under 13 yrs</small>
                            </p>
                            <p>
                              <small>on the day of travel</small>
                            </p>
                          </div>
                          <div className="d-col-number-select">
                            <Form.Group controlId={`validationChildAge${i}`}>
                              <Form.Control
                                as="select"
                                name={`childAge${i}`}
                                value={
                                  itinariesDataGet.no_children_travellers
                                    .children_age[i]
                                }
                                onChange={(e) => onChangeChildAge(e, i)}
                                required
                              >
                                <option value="">Select</option>
                                {/* <option value="1">1</option> */}
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                              </Form.Control>
                            </Form.Group>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <div className="mt-3">
                    <div className="d-col-number-group">
                      <div className="number-form-label">
                        <p>
                          Infant <small>0 to 2 years</small>
                        </p>
                        <p>
                          <small>on the day of travel</small>
                        </p>
                      </div>
                      <div className="d-col-number-field custom-add-rm-btn">
                        <button
                          type="button"
                          disabled={itinariesDataGet.no_infant_travellers < 1}
                          onClick={infantsdecrementCount}
                        >
                          <i className="bi bi-dash"></i>
                        </button>
                        <input
                          type="number"
                          name="infants"
                          value={itinariesDataGet.no_infant_travellers}
                          readOnly
                        />
                        <button type="button" onClick={infantsincrementCount}>
                          <i className="bi bi-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Tab.Container
                activeKey={activeDestinationKey}
                onSelect={(key) => {
                  setActiveDayKey("days1");
                  setActiveDestinationKey(key)
                }}
              >
                {itinariesDataGet.type_of_tour === "Multi City" ? (
                  <Nav variant="pills" className="mt-3 nav-multicity-tabs">
                    {itinariesDataGet.destinationCityDetails.map(
                      (destinationitem, i) => {
                        return (
                          <Nav.Item key={i}>
                            {destinationitem.destination_city.city ? (
                              <Nav.Link eventKey={`desItem${i}`}>
                                {destinationitem.destination_city.city}
                              </Nav.Link>
                            ) : (
                              ""
                            )}
                          </Nav.Item>
                        );
                      }
                    )}
                  </Nav>
                ) : (
                  ""
                )}
                <Tab.Content>
                  {itinariesDataGet.destinationCityDetails.map(
                    (destinationitem, i) => {
                      return (
                        <Tab.Pane eventKey={`desItem${i}`}>
                          <div className="mt-3">
                            {(itinariesDataGet.type_of_tour === "One Way" ||
                              itinariesDataGet.type_of_tour === "Round Trip" ||
                              itinariesDataGet.type_of_tour === "Multi City") &&
                              destinationitem.destination_city.city ? (
                              <h4 className="d-nav-tabs-title">
                                Destination City - <b>{destinationitem.destination_city.city}</b>
                              </h4>
                            ) : null}
                          </div>
                          <div className="row">
                            <div className="col-md-4 mt-3 d-flex align-items-end">
                              {destinationitem.tour_start_date ? (
                                <div className="d-col-number-days d-col-input-field">
                                  <label className="form-label">Days</label>
                                  <div className="d-col-number-field custom-daysAdd-Rm-btn">
                                    <input
                                      type="number"
                                      name="tour_no_of_days"
                                      value={
                                        i > 0
                                          ? dayCount(i)
                                          : destinationitem.tour_no_of_days
                                      }
                                      readOnly
                                    />
                                    <div className="daysAdd-minus-btns">
                                      <button
                                        type="button"
                                        onClick={(e) =>
                                          handleAddItem(e, destinationitem, i)
                                        }
                                      >
                                        <i className="bi bi-plus"></i>
                                      </button>
                                      <button
                                        type="button"
                                        disabled={
                                          destinationitem?.itineraryDatys?.length <
                                          2
                                        }
                                        onClick={(e) =>
                                          handleRemove(
                                            e,
                                            destinationitem?.itineraryDatys?.[
                                            destinationitem?.itineraryDatys
                                              ?.length - 1
                                            ],
                                            destinationitem,
                                            i,
                                            destinationitem?.itineraryDatys
                                              ?.length - 1
                                          )
                                        }
                                      >
                                        <i className="bi bi-dash"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          {destinationitem.tour_start_date ||
                            destinationitem._id ? (
                            <Tab.Container
                              activeKey={activeDayKey}
                              onSelect={(key) => setActiveDayKey(key)}
                            >
                              <div className="mt-3">
                                <Nav
                                  variant="pills"
                                  className="d-nav-tabs days-count-nav"
                                >
                                  {destinationitem.itineraryDatys.map(
                                    (daysitem, idx) => {
                                      return (
                                        <Nav.Item key={idx}>
                                          <Nav.Link
                                            eventKey={`days${daysitem.day}`}
                                          >
                                            <i
                                              className="bi bi-x-circle"
                                              onClick={(e) =>
                                                handleRemove(
                                                  e,
                                                  daysitem,
                                                  destinationitem,
                                                  i,
                                                  idx
                                                )
                                              }
                                            ></i>
                                            Day{" "}
                                            {i > 0
                                              ? dayNumber(
                                                i,
                                                daysitem.day,
                                                itinariesDataGet
                                              )
                                              : daysitem.day}
                                            <span>
                                              {daysitem.date
                                                ? moment(daysitem.date).format(
                                                  "DD MMMM yyyy"
                                                )
                                                : null}
                                            </span>
                                          </Nav.Link>
                                        </Nav.Item>
                                      );
                                    }
                                  )}
                                  <Nav.Item
                                    onClick={(e) =>
                                      handleAddItem(e, destinationitem, i)
                                    }
                                  >
                                    <span className="btn day-item-add btn-primary-color">
                                      <i className="bi bi-plus-lg"></i>
                                    </span>
                                  </Nav.Item>
                                </Nav>
                              </div>
                              {itineraryId ? (
                                <Tab.Content>
                                  {destinationitem?.itineraryDatys?.map(
                                    (daystabitem, x) => {
                                      let arrItineraryDay =
                                        !daystabitem?.itineraryDaysDetails
                                          ? []
                                          : [...daystabitem?.itineraryDaysDetails];
                                      return (
                                        <Tab.Pane
                                          eventKey={`days${daystabitem.day}`}
                                        >
                                          {(checkDateBlank || color === true) ? (
                                            <Nav
                                              variant="pills"
                                              className="d-nav2-tabs mb-2"
                                            >
                                              <Nav.Item>
                                                <OverlayTrigger
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip>
                                                      Please save first then you can
                                                      add details.
                                                    </Tooltip>
                                                  }
                                                >
                                                  <Nav.Link disabled={true}>
                                                    <div className="add-day-t">
                                                      <i className="icon-Transpott"></i>
                                                      <span>Transport</span>
                                                    </div>
                                                  </Nav.Link>
                                                </OverlayTrigger>
                                              </Nav.Item>
                                              <Nav.Item>
                                                <OverlayTrigger
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip>
                                                      Please save first then you can
                                                      add details.
                                                    </Tooltip>
                                                  }
                                                >
                                                  <Nav.Link disabled={true}>
                                                    <div className="add-day-t">
                                                      <i className="icon-Stays"></i>
                                                      <span>Stays</span>
                                                    </div>
                                                  </Nav.Link>
                                                </OverlayTrigger>
                                              </Nav.Item>
                                              <Nav.Item>
                                                <OverlayTrigger
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip>
                                                      Please save first then you can
                                                      add details.
                                                    </Tooltip>
                                                  }
                                                >
                                                  <Nav.Link disabled={true}>
                                                    <div className="add-day-t">
                                                      <i className="icon-Activity"></i>
                                                      <span>Activity</span>
                                                    </div>
                                                  </Nav.Link>
                                                </OverlayTrigger>
                                              </Nav.Item>
                                              <Nav.Item>
                                                <OverlayTrigger
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip>
                                                      Please save first then you can
                                                      add details.
                                                    </Tooltip>
                                                  }
                                                >
                                                  <Nav.Link disabled={true}>
                                                    <div className="add-day-t">
                                                      <i className="icon-Tours"></i>
                                                      <span>Tours</span>
                                                    </div>
                                                  </Nav.Link>
                                                </OverlayTrigger>
                                              </Nav.Item>
                                              <Nav.Item>
                                                <OverlayTrigger
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip>
                                                      Please save first then you can
                                                      add details.
                                                    </Tooltip>
                                                  }
                                                >
                                                  <Nav.Link disabled={true}>
                                                    <div className="add-day-t">
                                                      <i className="icon-Food"></i>
                                                      <span>Food</span>
                                                    </div>
                                                  </Nav.Link>
                                                </OverlayTrigger>
                                              </Nav.Item>
                                              <Nav.Item>
                                                <OverlayTrigger
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip>
                                                      Please save first then you can
                                                      add details.
                                                    </Tooltip>
                                                  }
                                                >
                                                  <Nav.Link disabled={true}>
                                                    <div className="add-day-t">
                                                      <i className="icon-Others"></i>
                                                      <span>Other</span>
                                                    </div>
                                                  </Nav.Link>
                                                </OverlayTrigger>
                                              </Nav.Item>
                                            </Nav>
                                          ) : (
                                            <Nav
                                              variant="pills"
                                              className="d-nav2-tabs mb-2"
                                            >
                                              <Nav.Item>
                                                <Nav.Link
                                                  //className="coming-soon-style"
                                                  onClick={(e) => {
                                                    setShowTransportModal(true);
                                                    setDestinationData(
                                                      destinationitem
                                                    );
                                                    setDayData(daystabitem);
                                                    setEditable(false);
                                                    setItemData(null);
                                                  }}
                                                >
                                                  <div className="add-day-t">
                                                    <i className="icon-Transpott"></i>
                                                    <span>Transport</span>
                                                  </div>
                                                </Nav.Link>
                                              </Nav.Item>
                                              <Nav.Item>
                                                <Nav.Link
                                                  onClick={(e) => {
                                                    setShowStaysModal(true);
                                                    setDestinationData(
                                                      destinationitem
                                                    );
                                                    setDayData(daystabitem);
                                                    setEditable(false);
                                                    setItemData(null);
                                                  }}
                                                >
                                                  <div className="add-day-t">
                                                    <i className="icon-Stays"></i>
                                                    <span>Stays</span>
                                                  </div>
                                                </Nav.Link>
                                              </Nav.Item>
                                              <Nav.Item>
                                                <Nav.Link
                                                  onClick={(e) => {
                                                    setShowActivityModal(true);
                                                    setDestinationData(
                                                      destinationitem
                                                    );
                                                    setDayData(daystabitem);
                                                    setEditable(false);
                                                    setItemData(null);
                                                  }}
                                                >
                                                  <div className="add-day-t">
                                                    <i className="icon-Activity"></i>
                                                    <span>Activity</span>
                                                  </div>
                                                </Nav.Link>
                                              </Nav.Item>
                                              <Nav.Item>
                                                <Nav.Link
                                                  // className="coming-soon-style"
                                                  onClick={(e) => {
                                                    setShowToursModal(true);
                                                    setDestinationData(
                                                      destinationitem
                                                    );
                                                    setDayData(daystabitem);
                                                    setEditable(false);
                                                    setItemData(null);
                                                  }}
                                                >
                                                  <div className="add-day-t">
                                                    <i className="icon-Tours"></i>
                                                    <span>Tours</span>
                                                  </div>
                                                </Nav.Link>
                                              </Nav.Item>
                                              <Nav.Item>
                                                <Nav.Link
                                                  onClick={(e) => {
                                                    setShowFoodModal(true);
                                                    setDestinationData(
                                                      destinationitem
                                                    );
                                                    setDayData(daystabitem);
                                                    setEditable(false);
                                                    setItemData(null);
                                                  }}
                                                >
                                                  <div className="add-day-t">
                                                    <i className="icon-Food"></i>
                                                    <span>Food</span>
                                                  </div>
                                                </Nav.Link>
                                              </Nav.Item>
                                              <Nav.Item>
                                                <Nav.Link
                                                  onClick={(e) => {
                                                    setShowOtherModal(true);
                                                    setDestinationData(
                                                      destinationitem
                                                    );
                                                    setDayData(daystabitem);
                                                    setEditable(false);
                                                    setItemData(null);
                                                  }}
                                                >
                                                  <div className="add-day-t">
                                                    <i className="icon-Others"></i>
                                                    <span>Other</span>
                                                  </div>
                                                </Nav.Link>
                                              </Nav.Item>
                                            </Nav>
                                          )}
                                          <div className="mt-4">
                                            {arrItineraryDay
                                              ?.sort((a, b) => {
                                                let a_time = a.time;
                                                let b_time = b.time;
                                                if (a?.tourStatus == "continue")
                                                  a_time = "00:00";
                                                if (b?.tourStatus == "continue")
                                                  b_time = "00:00";
                                                if (a?.tourStatus == "end")
                                                  a_time = timeFunc(a);
                                                if (b?.tourStatus == "end")
                                                  b_time = timeFunc(b);

                                                return a_time > b_time ? 1 : -1;
                                              })
                                              .map((item, d) => {
                                                return (
                                                  <DayItem
                                                    key={item._id}
                                                    item={item}
                                                    itemDeleteFnc={() =>
                                                      handleItineraryDaysDataDelete(
                                                        item
                                                      )
                                                    }
                                                    itemEditFnc={() => {
                                                      editItineraryFunc(item);
                                                      setDestinationData(
                                                        destinationitem
                                                      );
                                                      setDayData(daystabitem);
                                                    }}
                                                    dateCheck={checkDateBlank}
                                                  />
                                                );
                                              })}
                                          </div>
                                        </Tab.Pane>
                                      );
                                    }
                                  )}
                                </Tab.Content>
                              ) : (
                                ""
                              )}
                            </Tab.Container>
                          ) : (
                            ""
                          )}
                        </Tab.Pane>
                      );
                    }
                  )}
                </Tab.Content>
              </Tab.Container>
            </>
          )}
          <div className="form-btn-groups d-flex justify-content-end ci-buttons-bar">
            {itineraryId ? (
              <>
                <button
                  type="submit"
                  disabled={isDataLoading === true || isLoading}
                  onClick={() => (state.button = 2)}
                  className={
                    color
                      ? "btn btn-red-color border-radius-10 btn-height-58"
                      : "btn btn-primary-color border-radius-10 btn-height-58"
                  }
                >
                  {isDataLoading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      &nbsp;&nbsp;Saving...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-plus-circle"></i>&nbsp;&nbsp;Save
                    </>
                  )}
                </button>
                <button
                  type="button"
                  disabled={color === true || checkNullItinerary === true || isLoading}
                  onClick={() =>
                    history.push(
                      `/admin/itinerary-preview/?itineraryId=${itineraryId}`
                    )
                  }
                  className="btn btn-primary-color ms-2"
                >
                  Preview
                </button>
              </>
            ) : (
              <button
                type="submit"
                disabled={isDataLoading || isLoading}
                onClick={() => (state.button = 1)}
                className="btn btn-primary-color border-radius-10 btn-height-58"
              >
                {isDataLoading ? (
                  <>
                    <Spinner animation="border" size="sm" />
                    &nbsp;&nbsp;Loading...
                  </>
                ) : (
                  <>
                    <i className="bi bi-plus-circle"></i>&nbsp;&nbsp;Create
                  </>
                )}
              </button>
            )}
          </div>
        </Form>

      </div>

      {/* Add Transport Modal */}
      {showTransportModal && (
        <TransportModal
          showTransportModal={showTransportModal}
          setShowTransportModal={setShowTransportModal}
          dayData={dayData}
          destinationData={destinationData}
          returnFunction={() => getDraftData(itineraryId)}
          editable={editable}
          itemData={itemData}
        />
      )}

      {/* Add Activity Modal  */}
      {showActivityModal && (
        <ActivitiesModal
          showModal={showActivityModal}
          setShowModal={setShowActivityModal}
          dayData={dayData}
          destinationData={destinationData}
          returnFunction={() => getDraftData(itineraryId)}
          editable={editable}
          itemData={itemData}
        />
      )}
      {/* Add Food Modal */}
      {showFoodModal && (
        <FoodModal
          showFoodModal={showFoodModal}
          setShowFoodModal={setShowFoodModal}
          dayData={dayData}
          destinationData={destinationData}
          returnFunction={() => getDraftData(itineraryId)}
          editable={editable}
          itemData={itemData}
        />
      )}

      {/* Add Stays Modal */}
      {showStaysModal && (
        <StaysModal
          showStaysModal={showStaysModal}
          setShowStaysModal={setShowStaysModal}
          dayData={dayData}
          destinationData={destinationData}
          returnFunction={() => getDraftData(itineraryId)}
          editable={editable}
          itemData={itemData}
        />
      )}
      {/* Add Tours Modal */}
      {showToursModal && (
        <ToursModal
          showToursModal={showToursModal}
          setShowToursModal={setShowToursModal}
          dayData={dayData}
          destinationData={destinationData}
          returnFunction={() => getDraftData(itineraryId)}
          editable={editable}
          itemData={itemData}
        />
      )}
      {/* Add Others Modal */}
      {showOtherModal && (
        <OthersModal
          showOtherModal={showOtherModal}
          setShowOtherModal={setShowOtherModal}
          dayData={dayData}
          destinationData={destinationData}
          returnFunction={() => getDraftData(itineraryId)}
          editable={editable}
          itemData={itemData}
        />
      )}
    </>
  );
};

export default CreateItinerary;
